import { CommApiInstance } from "Utils/CommApiInstance";

const PymtMthdEvntApi = async (
    gameSvcCd:string,
    pymtMthd:string,
    prdtCd:string,
) => {
    
    return await CommApiInstance.post(`/pymt/${gameSvcCd}/pymt_mthd/evnt`,{
        apiBody:{
            pymtMthd:pymtMthd,
            prdtCd:prdtCd,
        },
    })
    .then((Resp) => Resp.data);
    
}
export default PymtMthdEvntApi;